import { getSpreadNameAsync } from "../components/navigation-bar/get-spread-names-async";
import { useAppContext } from "./useAppContext";
import { useErrorHandling } from "./useErrorHandling";
import { useProductCategory } from "./useProductCategory";
import { useProductCode } from "./useProductCode";
import { useQuery } from "@tanstack/react-query";
import { useSpreadCount } from "./useSpreadCount";

/**
 * Extracted logic for spread name
 */
export const useSpreadName = (spread: eXpress.core.Spread | undefined) => {
	const {
		localizedContent,
		context: { language },
	} = useAppContext();

	const { createErrorHandler } = useErrorHandling();

	// Some page labels depend on productCode or productCategory
	// We need to trigger an update when this changes
	const productCode = useProductCode();
	const productCategory = useProductCategory();
	const spreadCount = useSpreadCount();
	const spreadIndex = spread?.index ?? -1;

	const { data: spreadName } = useQuery(
		[
			"use-spread-name",
			spread?.oid, // spread or defintion changed
			spreadIndex, // spread position changed changed
			spreadCount, // spread added/removed,
			productCode,
			productCategory,
		],
		async () => {
			return getSpreadNameAsync(spread?.definition, spread, spreadIndex + 1, spreadCount, {
				getLocalizedMonthNames: () => eXpress.getLocalizedMonthNames(language),
				localizedContent,
			}).catch(createErrorHandler());
		},
		{
			keepPreviousData: true,
		},
	);

	return spreadName || "";
};
